var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "icon-service-dev" }, [
    _c(
      "svg",
      {
        attrs: {
          width: "100%",
          height: "100%",
          viewBox: "0 0 130 130",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c(
          "g",
          {
            attrs: {
              transform: "translate(-757 -34)",
              stroke: "#FFF",
              "stroke-width": "2",
              fill: "none",
              "fill-rule": "evenodd"
            }
          },
          [
            _c("ellipse", {
              attrs: {
                cx: "822",
                cy: "98",
                rx: "55",
                ry: "55",
                "stroke-dasharray": "345.02 345.02",
                "stroke-dashoffset": "345.02"
              }
            }),
            _c("path", {
              attrs: {
                d:
                  "M832.036 69L812 127.143M838.627 121.282l22.655-22.655-22.655-22.6M804.654 121.282L782 98.627l22.654-22.6",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-dasharray": "189.57 189.57",
                "stroke-dashoffset": "189.57"
              }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-262a57cb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262a57cb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icons/icon-service-dev-view.vue
// module id = 503
// module chunks = 74